import { render, staticRenderFns } from "./dialogUpdateGroupPosition.vue?vue&type=template&id=bb376a36&scoped=true"
import script from "./dialogUpdateGroupPosition.vue?vue&type=script&lang=js"
export * from "./dialogUpdateGroupPosition.vue?vue&type=script&lang=js"
import style0 from "./dialogUpdateGroupPosition.vue?vue&type=style&index=0&id=bb376a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb376a36",
  null
  
)

export default component.exports